import React, { useContext } from 'react';
import { Box, FormControl, FormControlLabel, FormLabel, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import intl from 'react-intl-universal';
import { MainContext, radioButtonValues } from 'context';
import { colors } from '@lifesize/clients.mui-components';
import { DIRECT_MEETING, EXISTING_MEETING, ONE_TIME_MEETING, ROOM_SYSTEM } from 'utils/constants/dataTestIds';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';

const MeetingTypeForm = ({ legendLabel, formControlClass, showOTM }: any) => {
  const { radioValue, setRadioValue, resetForm } = useContext(MainContext);
  const classes = useStyles();
  const isOneTimeMeetingEnabled = useSelector((state: RootState) => state.checkIn.account.features.oneTimeMeeting);

  return (
    <FormControl component="fieldset" className={formControlClass}>
      {legendLabel && (
        <FormLabel className={classes.formLabel} component="legend">
          {legendLabel}
        </FormLabel>
      )}

      <Box pl={1}>
        <RadioGroup
          aria-label="meetingType"
          name="meetingType"
          value={radioValue}
          onChange={(event: React.ChangeEvent<HTMLInputElement>, value: string) => {
            if (setRadioValue) setRadioValue(value as radioButtonValues);
            resetForm && resetForm();
          }}
        >
          <FormControlLabel
            {...DIRECT_MEETING}
            value={radioButtonValues.direct as string}
            control={<Radio />}
            label={intl.get('meetingTypeDirect')}
          />
          {showOTM && isOneTimeMeetingEnabled && (
            <FormControlLabel
              {...ONE_TIME_MEETING}
              value={radioButtonValues.oneTime}
              control={<Radio />}
              label={intl.get('meetingTypeOneTime')}
            />
          )}
          <FormControlLabel
            {...EXISTING_MEETING}
            value={radioButtonValues.find}
            control={<Radio />}
            label={intl.get('meetingTypeFind')}
          />
          <FormControlLabel
            {...ROOM_SYSTEM}
            value={radioButtonValues.findRoom}
            control={<Radio />}
            label={intl.get('roomSystemTypeFind')}
          />
        </RadioGroup>
      </Box>
    </FormControl>
  );
};

export default MeetingTypeForm;

const useStyles = makeStyles((theme: Theme) => ({
  formLabel: {
    paddingBottom: theme.spacing(1),
    color: colors.black,
    fontWeight: 600,
    fontSize: '1.5rem'
  }
}));
